export default __webpack_public_path__ + "static/media/AnthonyKinley.cf034610.jpg";